import {createFileRoute} from '@tanstack/react-router';

import Confirm from '@/anonymous/views/ConfirmAccount';

export const Route = createFileRoute('/(anonymous)/confirm')({
  component: Confirm
});
